// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppointmentCard-module__card___rmOzz {
  position: relative;
  width: 100%;
  display: block;
  text-align: left;
  appearance: none;
  background: #fff;
  border: 1.5px solid var(--card-border);
  border-left: 4px solid var(--card-left);
  border-radius: 8px;
  padding: 12px 14px;
  cursor: pointer;
  transition: border-color 0.15s, background-color 0.15s, box-shadow 0.15s, transform 0.15s;
  font: inherit;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.AppointmentCard-module__dismissButton___USe6o {
  position: absolute;
  top: 6px;
  right: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  border-radius: 4px;
  color: #a1a1aa;
  background: transparent;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s ease, color 0.15s ease, background 0.15s ease;
}

.AppointmentCard-module__card___rmOzz:hover .AppointmentCard-module__dismissButton___USe6o,
.AppointmentCard-module__dismissButton___USe6o:focus-visible {
  opacity: 1;
}

.AppointmentCard-module__dismissButton___USe6o:hover,
.AppointmentCard-module__dismissButton___USe6o:focus-visible {
  color: #52525b;
  background: #f4f4f5;
  outline: none;
}

.AppointmentCard-module__selected___JCjcb {
  background: #ffffff;
  border-color: #18181b;
  border-left-color: #18181b;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);
}

.AppointmentCard-module__card___rmOzz:not(.AppointmentCard-module__selected___JCjcb):hover {
  background: #ffffff;
  border-color: var(--card-border);
  border-left-color: var(--card-left);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  transform: translateY(-1px);
}

.AppointmentCard-module__card___rmOzz:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.AppointmentCard-module__header___D0euc {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 6px;
}

.AppointmentCard-module__patientName___SwTal {
  font-size: 15px;
  font-weight: 600;
  color: #18181b;
  line-height: 1.35;
}

.AppointmentCard-module__visitMeta___PuSHj {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  font-size: 12px;
  color: #52525b;
  margin-top: 2px;
}

.AppointmentCard-module__metaDivider___DNIGJ {
  color: #d4d4d8;
}

.AppointmentCard-module__department___FsWLY {
  color: #16a34a;
  font-weight: 600;
}

.AppointmentCard-module__clinician___KPJTu {
  font-weight: 500;
}

.AppointmentCard-module__dateBlock___r_OTS {
  text-align: right;
  padding-left: 10px;
}

.AppointmentCard-module__timeGroup___OfX4G {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 2px;
}

.AppointmentCard-module__dateLabel___yKl7B {
  font-size: 12px;
  font-weight: 600;
  font-family: "IBM Plex Mono", monospace;
}

.AppointmentCard-module__dateSoon___kHK16 {
  color: #18181b;
}

.AppointmentCard-module__dateNormal___DfLGl {
  color: #71717a;
}

.AppointmentCard-module__timeLabel___w1pES {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  font-size: 11px;
  color: #a1a1aa;
  font-family: "IBM Plex Mono", monospace;
  white-space: nowrap;
}

.AppointmentCard-module__timeCaption___UVaql {
  color: #71717a;
  font-weight: 600;
}

.AppointmentCard-module__timeSubLabel___tgu8b {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  font-size: 11px;
  color: #71717a;
  font-family: "IBM Plex Mono", monospace;
  white-space: nowrap;
}

.AppointmentCard-module__footer___MxSwU {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 10px;
}

.AppointmentCard-module__readinessRow___hnwwM {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 120px;
  flex-wrap: wrap;
}

.AppointmentCard-module__readinessLabel___UixLe {
  font-size: 12px;
  color: #71717a;
  font-weight: 500;
}

.AppointmentCard-module__readinessBlocks___V6BKj {
  display: flex;
  gap: 2px;
  flex-wrap: wrap;
  max-width: 100%;
}

.AppointmentCard-module__readinessBlock___Tv3SI {
  width: 10px;
  height: 10px;
  border-radius: 2px;
}

.AppointmentCard-module__readinessBlockgreen___mQITc {
  background: #22c55e;
}

.AppointmentCard-module__readinessBlockyellow___kplqg {
  background: #eab308;
}

.AppointmentCard-module__readinessBlockcanceled___xXhyf {
  background: #d4d4d8;
}

.AppointmentCard-module__readinessBlockred___EeK9m {
  background: #ef4444;
}

.AppointmentCard-module__readinessCount___osKT6 {
  font-size: 12px;
  color: #71717a;
  font-family: "IBM Plex Mono", monospace;
}

.AppointmentCard-module__followUpRow___WsTlY {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 140px;
  flex-wrap: wrap;
}

.AppointmentCard-module__followUpBar___SzpYS {
  flex: 1;
  min-width: 40px;
  height: 6px;
  background: #f4f4f5;
  border-radius: 3px;
  overflow: hidden;
}

.AppointmentCard-module__followUpBarFill___MbIvu {
  height: 100%;
  border-radius: 3px;
  transition: width 0.2s ease;
}

.AppointmentCard-module__followUpBarFillgreen____jELj {
  background: #22c55e;
}

.AppointmentCard-module__followUpBarFillyellow___gmZzi {
  background: #eab308;
}

.AppointmentCard-module__followUpBarFillred___hu8ib {
  background: #ef4444;
}

.AppointmentCard-module__followUpBarFillneutral___HDr95 {
  background: #d4d4d8;
}

.AppointmentCard-module__rollingPill___kSKx4 {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  margin-left: auto;
}

.AppointmentCard-module__rollingIcon___LmSA8 {
  opacity: 0.7;
}

.AppointmentCard-module__rollingPillred___ITR0M {
  border: 1px solid #fecaca;
  background: #fef2f2;
  color: #991b1b;
}

.AppointmentCard-module__rollingPillyellow___hQuIh {
  border: 1px solid #fde68a;
  background: #fffbeb;
  color: #92400e;
}

.AppointmentCard-module__rollingPillneutral___pDfO_ {
  border: 1px solid #e4e4e7;
  background: #fafafa;
  color: #71717a;
}

.AppointmentCard-module__footer___MxSwU .AppointmentCard-module__mocaFlag___B4bEx {
  padding: 2px 6px;
  font-size: 11px;
}

.AppointmentCard-module__huddleNoteCount___rTcrt {
  margin-top: 6px;
}

.AppointmentCard-module__taskPill___UhuCB {
  flex-shrink: 0;
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid #fecaca;
  background: #fef2f2;
  font-size: 11px;
  font-weight: 500;
  color: #991b1b;
  margin-left: auto;
}

.AppointmentCard-module__taskPillDone___YQqNJ {
  flex-shrink: 0;
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid #bbf7d0;
  background: #f0fdf4;
  font-size: 11px;
  font-weight: 500;
  color: #166534;
  margin-left: auto;
}

.AppointmentCard-module__taskPillMuted___o4kgI {
  flex-shrink: 0;
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid #e4e4e7;
  background: #fafafa;
  font-size: 11px;
  font-weight: 500;
  color: #71717a;
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/AppointmentCard/AppointmentCard.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,uCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,yFAAA;EAEA,aAAA;EACA,yCAAA;AAAF;;AAGA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,uEAAA;AAAF;;AAGA;;EAEE,UAAA;AAAF;;AAGA;;EAEE,cAAA;EACA,mBAAA;EACA,aAAA;AAAF;;AAGA;EACE,mBAAA;EACA,qBAAA;EACA,0BAAA;EACA,0CAAA;AAAF;;AAGA;EACE,mBAAA;EACA,gCAAA;EACA,mCAAA;EACA,0CAAA;EACA,2BAAA;AAAF;;AAGA;EACE,0BAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,uCAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,uCAAA;EACA,mBAAA;AAAF;;AAGA;EACE,cAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,uCAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,OAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,eAAA;EACA,cAAA;EACA,uCAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,OAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,OAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,YAAA;EACA,kBAAA;EACA,2BAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAAF;;AAGA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAAF;;AAGA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAAF","sourcesContent":[".card {\n  position: relative;\n  width: 100%;\n  display: block;\n  text-align: left;\n  appearance: none;\n  background: #fff;\n  border: 1.5px solid var(--card-border);\n  border-left: 4px solid var(--card-left);\n  border-radius: 8px;\n  padding: 12px 14px;\n  cursor: pointer;\n  transition: border-color 0.15s, background-color 0.15s, box-shadow 0.15s,\n    transform 0.15s;\n  font: inherit;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.dismissButton {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px;\n  border-radius: 4px;\n  color: #a1a1aa;\n  background: transparent;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.15s ease, color 0.15s ease, background 0.15s ease;\n}\n\n.card:hover .dismissButton,\n.dismissButton:focus-visible {\n  opacity: 1;\n}\n\n.dismissButton:hover,\n.dismissButton:focus-visible {\n  color: #52525b;\n  background: #f4f4f5;\n  outline: none;\n}\n\n.selected {\n  background: #ffffff;\n  border-color: #18181b;\n  border-left-color: #18181b;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);\n}\n\n.card:not(.selected):hover {\n  background: #ffffff;\n  border-color: var(--card-border);\n  border-left-color: var(--card-left);\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);\n  transform: translateY(-1px);\n}\n\n.card:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 6px;\n}\n\n.patientName {\n  font-size: 15px;\n  font-weight: 600;\n  color: #18181b;\n  line-height: 1.35;\n}\n\n.visitMeta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n  font-size: 12px;\n  color: #52525b;\n  margin-top: 2px;\n}\n\n.metaDivider {\n  color: #d4d4d8;\n}\n\n.department {\n  color: #16a34a;\n  font-weight: 600;\n}\n\n.clinician {\n  font-weight: 500;\n}\n\n.dateBlock {\n  text-align: right;\n  padding-left: 10px;\n}\n\n.timeGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-top: 2px;\n}\n\n.dateLabel {\n  font-size: 12px;\n  font-weight: 600;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.dateSoon {\n  color: #18181b;\n}\n\n.dateNormal {\n  color: #71717a;\n}\n\n.timeLabel {\n  display: flex;\n  justify-content: flex-end;\n  gap: 4px;\n  font-size: 11px;\n  color: #a1a1aa;\n  font-family: 'IBM Plex Mono', monospace;\n  white-space: nowrap;\n}\n\n.timeCaption {\n  color: #71717a;\n  font-weight: 600;\n}\n\n.timeSubLabel {\n  display: flex;\n  justify-content: flex-end;\n  gap: 4px;\n  font-size: 11px;\n  color: #71717a;\n  font-family: 'IBM Plex Mono', monospace;\n  white-space: nowrap;\n}\n\n.footer {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top: 10px;\n}\n\n.readinessRow {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 1;\n  min-width: 120px;\n  flex-wrap: wrap;\n}\n\n.readinessLabel {\n  font-size: 12px;\n  color: #71717a;\n  font-weight: 500;\n}\n\n.readinessBlocks {\n  display: flex;\n  gap: 2px;\n  flex-wrap: wrap;\n  max-width: 100%;\n}\n\n.readinessBlock {\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n}\n\n.readinessBlockgreen {\n  background: #22c55e;\n}\n\n.readinessBlockyellow {\n  background: #eab308;\n}\n\n.readinessBlockcanceled {\n  background: #d4d4d8;\n}\n\n.readinessBlockred {\n  background: #ef4444;\n}\n\n.readinessCount {\n  font-size: 12px;\n  color: #71717a;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.followUpRow {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 1;\n  min-width: 140px;\n  flex-wrap: wrap;\n}\n\n.followUpBar {\n  flex: 1;\n  min-width: 40px;\n  height: 6px;\n  background: #f4f4f5;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.followUpBarFill {\n  height: 100%;\n  border-radius: 3px;\n  transition: width 0.2s ease;\n}\n\n.followUpBarFillgreen {\n  background: #22c55e;\n}\n\n.followUpBarFillyellow {\n  background: #eab308;\n}\n\n.followUpBarFillred {\n  background: #ef4444;\n}\n\n.followUpBarFillneutral {\n  background: #d4d4d8;\n}\n\n.rollingPill {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  margin-left: auto;\n}\n\n.rollingIcon {\n  opacity: 0.7;\n}\n\n.rollingPillred {\n  border: 1px solid #fecaca;\n  background: #fef2f2;\n  color: #991b1b;\n}\n\n.rollingPillyellow {\n  border: 1px solid #fde68a;\n  background: #fffbeb;\n  color: #92400e;\n}\n\n.rollingPillneutral {\n  border: 1px solid #e4e4e7;\n  background: #fafafa;\n  color: #71717a;\n}\n\n.footer .mocaFlag {\n  padding: 2px 6px;\n  font-size: 11px;\n}\n\n.huddleNoteCount {\n  margin-top: 6px;\n}\n\n.taskPill {\n  flex-shrink: 0;\n  padding: 2px 6px;\n  border-radius: 4px;\n  border: 1px solid #fecaca;\n  background: #fef2f2;\n  font-size: 11px;\n  font-weight: 500;\n  color: #991b1b;\n  margin-left: auto;\n}\n\n.taskPillDone {\n  flex-shrink: 0;\n  padding: 2px 6px;\n  border-radius: 4px;\n  border: 1px solid #bbf7d0;\n  background: #f0fdf4;\n  font-size: 11px;\n  font-weight: 500;\n  color: #166534;\n  margin-left: auto;\n}\n\n.taskPillMuted {\n  flex-shrink: 0;\n  padding: 2px 6px;\n  border-radius: 4px;\n  border: 1px solid #e4e4e7;\n  background: #fafafa;\n  font-size: 11px;\n  font-weight: 500;\n  color: #71717a;\n  margin-left: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `AppointmentCard-module__card___rmOzz`,
	"dismissButton": `AppointmentCard-module__dismissButton___USe6o`,
	"selected": `AppointmentCard-module__selected___JCjcb`,
	"header": `AppointmentCard-module__header___D0euc`,
	"patientName": `AppointmentCard-module__patientName___SwTal`,
	"visitMeta": `AppointmentCard-module__visitMeta___PuSHj`,
	"metaDivider": `AppointmentCard-module__metaDivider___DNIGJ`,
	"department": `AppointmentCard-module__department___FsWLY`,
	"clinician": `AppointmentCard-module__clinician___KPJTu`,
	"dateBlock": `AppointmentCard-module__dateBlock___r_OTS`,
	"timeGroup": `AppointmentCard-module__timeGroup___OfX4G`,
	"dateLabel": `AppointmentCard-module__dateLabel___yKl7B`,
	"dateSoon": `AppointmentCard-module__dateSoon___kHK16`,
	"dateNormal": `AppointmentCard-module__dateNormal___DfLGl`,
	"timeLabel": `AppointmentCard-module__timeLabel___w1pES`,
	"timeCaption": `AppointmentCard-module__timeCaption___UVaql`,
	"timeSubLabel": `AppointmentCard-module__timeSubLabel___tgu8b`,
	"footer": `AppointmentCard-module__footer___MxSwU`,
	"readinessRow": `AppointmentCard-module__readinessRow___hnwwM`,
	"readinessLabel": `AppointmentCard-module__readinessLabel___UixLe`,
	"readinessBlocks": `AppointmentCard-module__readinessBlocks___V6BKj`,
	"readinessBlock": `AppointmentCard-module__readinessBlock___Tv3SI`,
	"readinessBlockgreen": `AppointmentCard-module__readinessBlockgreen___mQITc`,
	"readinessBlockyellow": `AppointmentCard-module__readinessBlockyellow___kplqg`,
	"readinessBlockcanceled": `AppointmentCard-module__readinessBlockcanceled___xXhyf`,
	"readinessBlockred": `AppointmentCard-module__readinessBlockred___EeK9m`,
	"readinessCount": `AppointmentCard-module__readinessCount___osKT6`,
	"followUpRow": `AppointmentCard-module__followUpRow___WsTlY`,
	"followUpBar": `AppointmentCard-module__followUpBar___SzpYS`,
	"followUpBarFill": `AppointmentCard-module__followUpBarFill___MbIvu`,
	"followUpBarFillgreen": `AppointmentCard-module__followUpBarFillgreen____jELj`,
	"followUpBarFillyellow": `AppointmentCard-module__followUpBarFillyellow___gmZzi`,
	"followUpBarFillred": `AppointmentCard-module__followUpBarFillred___hu8ib`,
	"followUpBarFillneutral": `AppointmentCard-module__followUpBarFillneutral___HDr95`,
	"rollingPill": `AppointmentCard-module__rollingPill___kSKx4`,
	"rollingIcon": `AppointmentCard-module__rollingIcon___LmSA8`,
	"rollingPillred": `AppointmentCard-module__rollingPillred___ITR0M`,
	"rollingPillyellow": `AppointmentCard-module__rollingPillyellow___hQuIh`,
	"rollingPillneutral": `AppointmentCard-module__rollingPillneutral___pDfO_`,
	"mocaFlag": `AppointmentCard-module__mocaFlag___B4bEx`,
	"huddleNoteCount": `AppointmentCard-module__huddleNoteCount___rTcrt`,
	"taskPill": `AppointmentCard-module__taskPill___UhuCB`,
	"taskPillDone": `AppointmentCard-module__taskPillDone___YQqNJ`,
	"taskPillMuted": `AppointmentCard-module__taskPillMuted___o4kgI`
};
module.exports = ___CSS_LOADER_EXPORT___;
